import { PlusOneFormValue } from 'components/discover/event/EventView/PlusOneForm';

export type ModalStep = 'selectGuest' | 'form' | 'notifications';

export interface PlusOneModalState {
  currentStep: ModalStep;
  previousStep: ModalStep | null;
  pendingFormValues: PlusOneFormValue | null;
  pendingSelectedPlusOneIds: number[] | null;
}

export type PlusOneModalAction =
  | { type: 'GO_TO_STEP'; step: ModalStep }
  | { type: 'SUBMIT_FORM'; values: PlusOneFormValue }
  | { type: 'SUBMIT_SELECT_GUEST'; selectedPlusOneIds: number[] }
  | { type: 'BACK_FROM_NOTIFICATIONS' }
  | { type: 'RETURN_TO_SELECT_GUEST' }
  | { type: 'RESET'; initialStep: ModalStep };

export const plusOneModalReducer = (
  state: PlusOneModalState,
  action: PlusOneModalAction
): PlusOneModalState => {
  switch (action.type) {
    case 'GO_TO_STEP':
      return {
        ...state,
        previousStep: state.currentStep,
        currentStep: action.step
      };

    case 'SUBMIT_FORM':
      return {
        ...state,
        pendingFormValues: action.values,
        previousStep: state.currentStep,
        currentStep: 'notifications'
      };

    case 'SUBMIT_SELECT_GUEST':
      return {
        ...state,
        pendingSelectedPlusOneIds: action.selectedPlusOneIds,
        previousStep: state.currentStep,
        currentStep: 'notifications'
      };

    case 'BACK_FROM_NOTIFICATIONS':
      return {
        ...state,
        currentStep: state.previousStep ?? 'form',
        previousStep: null
      };

    case 'RETURN_TO_SELECT_GUEST':
      return {
        ...state,
        currentStep: 'selectGuest',
        previousStep: null,
        pendingFormValues: null,
        pendingSelectedPlusOneIds: null
      };

    case 'RESET':
      return {
        currentStep: action.initialStep,
        previousStep: null,
        pendingFormValues: null,
        pendingSelectedPlusOneIds: null
      };

    default:
      return state;
  }
};
